const SportType = {
    Baseball: { key: 'BASEBALL', name: 'Baseball'},
    Softball: { key: 'SOFTBALL', name: 'Softball'},
    Unknown: { key: 'UNKNOWN', name: 'Unknown'},
};

export default SportType;